module.exports = __webpack_public_path__ + "static/media/add_to_drive_black_24dp.eba71d22.svg";